import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import { CartContextProvider } from '@/contexts/CartContext';

import GiftCard from './giftcard';

declare global {
    interface Window {
        translations?: Record<string, string>;
    }
}

const ErrorFallback = () => {
    return <div className="">loading</div>;
};

const GiftCardApp = () => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: Infinity,
            },
        },
    });
    const persister = createSyncStoragePersister({
        storage: window.localStorage,
    });

    const giftCardUrl =
        element?.getAttribute('data-gift-card-url') || window.tscConfig?.GiftCardPageUrl || '/gift-cards';

    const translate = (key: string) => {
        return window.translations?.[key] || key;
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <PersistQueryClientProvider client={client} persistOptions={{ persister }}>
                <ReactQueryDevtools initialIsOpen={false} />
                <CartContextProvider value={{ cartData: null }}>
                    <GiftCard translate={translate} giftCardPageUrl={giftCardUrl} />
                </CartContextProvider>
            </PersistQueryClientProvider>
        </ErrorBoundary>
    );
};

const id = 'gift-card';
const element = document.getElementById(id);
const root = ReactDOM.createRoot(element);
if (element) {
    root.render(
        <React.StrictMode>
            <GiftCardApp />
        </React.StrictMode>,
    );
}
